export default __webpack_public_path__ + "static/media/orange-juice-menu-bg@3x.ae007660.png";